import { Button, Typography } from '@mui/material'
import doPrimaryLogoUrl from '@/assets/Logo/do-Primary-black.svg'
import styles from './SecondaryNavHeaderTitle.module.scss'

function SecondaryNavHeaderTitle({ title, highlighted = true }) {
  const isHome = title === 'Home'

  return (
    <Button
      type="button"
      variant="text"
      aria-label={isHome ? 'Home' : title}
      className={`${styles.headerButton} ${title === 'Chambers' ? styles.chambersWidth : styles.homeWidth
        } ${highlighted ? styles.highlighted : ''}`}
    >
      {isHome ? (
        <img src={doPrimaryLogoUrl} alt="" className={styles.logoImg} width={108} height={14} decoding="async" />
      ) : (
        <Typography component="span" className={styles.title}>
          {title}
        </Typography>
      )}
    </Button>
  )
}

export default SecondaryNavHeaderTitle
